function priorityByRule(rule, property) {
  var _rule$style;

  return ((_rule$style = rule.style) === null || _rule$style === void 0 ? void 0 : _rule$style.getPropertyPriority(property)) === "important" ? 100000 : 0;
}

export { priorityByRule };